import { axiosClient } from "utilz";

export const getMachineToken = async () => {
  try {
    const url = "/controlcenter/machine/token";
    const response = await axiosClient.post(`${url}`);
    const resData = response?.data;
    if (resData?.status === "success" && resData?.statusCode === 200) {
      return resData?.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};
